require('./bootstrap');

import Vue from 'vue';
import store from './store';
import vuetify from './plugins/vuetify'; // path to vuetify export
import router from './router';

import SimpleLayout from './layouts/SimpleLayout';
import AppLayout from './layouts/AppLayout';

const app = new Vue({
  vuetify,
  store,
  router,
  computed: {
    layout() {
      return this.$store.getters.layout;
    }
  },
  components: { 'app-layout': AppLayout, 'simple-layout': SimpleLayout }
}).$mount('#app');

window.app = app;
